import * as React from "react"

export default function AddIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.168 9.667h.5v-5h.667v5h5v.666h-5v5h-.667v-5h-5v-.666h4.5z"
        fill={props.fill}
        stroke={props.fill}
      />
    </svg>
  )
}
